import { PostloadedIframe as PostloadedIframe$1 } from '@pm2/react-utils';
import { fadeInCls } from './comp.content.style.js';
import { jsx } from 'react/jsx-runtime';

function PostloadedIframe({
  ref,
  ...props
}) {
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: fadeInCls,
    children: /*#__PURE__*/jsx(PostloadedIframe$1, {
      ...props,
      src: props.src ? window.gProxy.forwardTo(props.src) : undefined
    })
  });
}

export { PostloadedIframe };
//# sourceMappingURL=atom.postloaded-iframe.js.map
